/**
 * Spanish catalogs.
 *
 * These ship intentionally incomplete. Any key absent here falls back to the
 * English catalog (fallbackLng), so a partially translated namespace renders
 * mixed English/Spanish rather than raw key names or blanks — that is what lets
 * extraction land ahead of translation.
 *
 * Run `npm run i18n:report` for the outstanding translation work list.
 */

import admin from './admin.json';
import analytics from './analytics.json';
import auth from './auth.json';
import badges from './badges.json';
import common from './common.json';
import drawings from './drawings.json';
import errors from './errors.json';
import legal from './legal.json';
import reports from './reports.json';
import settings from './settings.json';
import support from './support.json';

export default {
  admin,
  analytics,
  auth,
  badges,
  common,
  drawings,
  errors,
  legal,
  reports,
  settings,
  support,
};
